import { useEffect, useState } from "react";

const SearchOrder = ({ filter, setFilter }) => {
  //Debouncing

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      inputValue.length > 2 ? setFilter(inputValue) : setFilter("");
    }, 1000);

    // Cleanup function to cancel the timeout if the user types again
    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  return (
    <div className="search-box">
      <div className="search-box relative d-flex align-center">
        <input
          type="text"
          className="form-control"
          placeholder="Search"
          value={inputValue || ""}
          onChange={handleInputChange}
        />
        <button type="button" className="search-btn">
          <img src="/images/search-icon.svg" alt="" />
        </button>
      </div>

      <p
        className={`error mb-0 mt-2 ${inputValue.length > 0 && inputValue.length < 3 ? "visible" : "invisible"}`}
        style={{
          position: "absolute",
          bottom: "-20px",
          left: "0",
          width: "100%",
        }}
      >
        Please enter atleast 3 character to search
      </p>
    </div>
  );
};

export { SearchOrder };
